import { useSearchParams } from 'next/navigation'
import styled from 'styled-components'

import SvgVerifError from '../../shared/svg/verif-error.svg'
import SvgVerifFailed from '../../shared/svg/verif-failed.svg'
import SvgVerifSuccess from '../../shared/svg/verif-success.svg'

export const Verif = () => {
	const params = useSearchParams()

	const error = params?.get('error')
	const errorDescription = params?.get('error_description')

	const isAuthorizationFailed = error === 'authorization_failed'
	const isSuccess = !error
	const isError = isAuthorizationFailed ? false : error

	return (
		<Wrap>
			{isError && (
				<Content>
					<VerifError />
					<Title>{error}</Title>
					<Text>{errorDescription}</Text>
				</Content>
			)}
			{isAuthorizationFailed && (
				<Content>
					<VerifFailed />
					<Title>Данные из Госуслуг не соответствуют данным пользователя</Title>
					<Text>Убедитесь, что Вы вошли под своей учетной записью</Text>
				</Content>
			)}
			{isSuccess && (
				<Content>
					<VerifSuccess />
					<Title>Поздравляем, вы успешно прошли верификацию</Title>
				</Content>
			)}
		</Wrap>
	)
}

const Wrap = styled.div({
	display: 'flex',
	height: '-webkit-fill-available',
	justifyContent: 'center',
	alignItems: 'center',
})

const Content = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'center',
	justifyContent: 'center',
	alignItems: 'center',
	maxWidth: 450,
	gap: 8,
}))

const Title = styled.h1(({ theme }) => ({
	...theme.typography.header24_28,
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text20_28,
}))

const VerifSuccess = styled(SvgVerifSuccess)({
	height: 'unset',
	width: 'unset',
})

const VerifError = styled(SvgVerifError)({
	height: 'unset',
	width: 'unset',
})

const VerifFailed = styled(SvgVerifFailed)({
	height: 'unset',
	width: 'unset',
})
